export * from "./stereoscopicInterlacePostProcess.pure";

import "../Shaders/stereoscopicInterlace.fragment";
